import { Site } from 'src/types/model';

import { useRouteContext } from './useRouteContext';

export const useSite = () => {
  const { routeData } = useRouteContext();
  const site: Site = routeData?.context.site ?? 'main';

  return {
    site,
    isMainSite: site === 'main',
    isEastAsiaSite: site === 'eastasia',
  };
};
